(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pivot-combined-listings"] && !Shopify.designMode) return;
  try {
    class PvtCombinedListings extends HTMLElement {
    connectedCallback() {
      const items = this.querySelectorAll('.pivot-combined-listings__link');
      items.forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = el.getAttribute('data-href');
        });
      });
    }
  }
  if (!customElements.get('pivot-combined-listings')) {
    customElements.define('pivot-combined-listings', PvtCombinedListings);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-sku"] && !Shopify.designMode) return;
  try {
    class PivotProductSku extends HTMLElement {
    constructor() {
      super();
      this.currentUrl = window.location.href;
      
      // Inicializar cuando el DOM esté listo
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }
    
    init() {
      // Escuchar por cambios en el historial (cuando se navega entre variantes)
      window.addEventListener('popstate', () => this.handleUrlChange());
      
      // También observamos cambios en la URL con history.pushState/replaceState
      this.overrideHistoryMethods();
    }
    
    overrideHistoryMethods() {
      const self = this;
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;
      
      history.pushState = function() {
        originalPushState.apply(this, arguments);
        self.handleUrlChange();
      };
      
      history.replaceState = function() {
        originalReplaceState.apply(this, arguments);
        self.handleUrlChange();
      };
    }
    
    handleUrlChange() {
      if (this.currentUrl !== window.location.href) {
        this.currentUrl = window.location.href;
        this.updateSku();
      }
    }
    
    updateSku() {
      fetch(window.location.href)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Buscar el elemento con el mismo ID en el nuevo HTML
          const newSkuElement = doc.getElementById(this.id);
          
          if (newSkuElement && this) {
            this.innerHTML = newSkuElement.innerHTML;
          }
        })
        .catch(error => {
          console.error('Error al actualizar el SKU:', error);
        });
    }
  }
  
  // Definir el elemento personalizado
  if (!customElements.get('pivot-product-sku')) {
    customElements.define('pivot-product-sku', PivotProductSku);
  }
  } catch(e) { console.error(e); }
})();

})();
